export default __webpack_public_path__ + "static/media/Flag_of_Hong_Kong.f6da2945.svg";